import { isRTL } from "@core/shared/utils";
import * as React from "react";
import { cn } from "../../utils/helpers";
import { TabsContent } from "./TabsContent";
import { TabsList } from "./TabsList";
import { type TabProps, type TabsProps } from "./types";
export { Tab } from "./Tab";

export function Tabs({
  value,
  defaultValue,
  onValueChange,
  orientation = "horizontal",
  children,
  className,
  keepMounted = false,
  id = "tabs",
}: TabsProps) {
  const tabs = React.Children.toArray(
    children,
  ) as React.ReactElement<TabProps>[];
  const isControlled = value !== undefined;

  const [internalValue, setInternalValue] = React.useState(
    defaultValue ?? tabs[0]?.props.value,
  );

  const activeTab = isControlled ? value : internalValue;

  const handleTabChange = React.useCallback(
    (newValue: string) => {
      if (!isControlled) {
        setInternalValue(newValue);
      }
      onValueChange?.(newValue);
    },
    [isControlled, onValueChange],
  );

  const isRTLValue = isRTL();

  return (
    <div
      className={cn(
        "w-full",
        orientation === "vertical"
          ? "flex flex-row gap-4"
          : "flex flex-col gap-2",
        isRTLValue && "rtl",
        className,
      )}>
      <TabsList
        tabs={tabs}
        activeTab={activeTab}
        orientation={orientation}
        onTabChange={handleTabChange}
        baseId={id}
      />
      <TabsContent
        tabs={tabs}
        activeTab={activeTab}
        keepMounted={keepMounted}
        baseId={id}
      />
    </div>
  );
}
